import { JSXElement, lazy } from 'solid-js';
import { EnvAppPaths, getSlug } from '~/components/AppRouter/utils.ts';
import { Navigate, Route } from '@solidjs/router';
import {
  getEnvPagePageComponent,
  LayoutTypes
} from '~/components/Layout/utils.tsx';
import {
  allOf,
  anyOf,
  EnvAppPermissions
} from '~/components/Authorization/utils.ts';

const Passkeys = lazy(
  () => import('~/pages/ExternalPages/EnvAppPages/Passkeys')
);
const WorkspaceSettings = lazy(
  () => import('~/pages/ExternalPages/EnvAppPages/WorkspaceSettings')
);
const MyProfile = lazy(
  () => import('~/pages/ExternalPages/EnvAppPages/MyAccount/MyAccount.tsx')
);
const Users = lazy(() => import('~/pages/ExternalPages/EnvAppPages/Users'));
const Security = lazy(
  () => import('~/pages/ExternalPages/EnvAppPages/Security')
);
const Sso = lazy(() => import('~/pages/ExternalPages/EnvAppPages/Sso'));
const Scim = lazy(() => import('~/pages/ExternalPages/EnvAppPages/Scim'));

export default function EnvAppPagesRoutes(): JSXElement {
  return (
    <Route path={getSlug.getEnvAppPagesBaseNamespace()}>
      <Route
        path={`/`}
        component={getEnvPagePageComponent(
          () => (
            <Navigate
              href={getSlug.envAppPages(EnvAppPaths.MY_ACCOUNT, true)}
            />
          ),
          LayoutTypes.TWO_COLUMN_WITH_NAV
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.PASSKEYS)}
        component={Passkeys}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.MANAGE_WORKSPACE)}
        component={getEnvPagePageComponent(
          WorkspaceSettings,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            )
          )
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.USERS)}
        component={getEnvPagePageComponent(
          Users,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            ),
            anyOf(EnvAppPermissions.ORG_USERS_READ)
          )
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.LIST_DIRECTORIES)}
        component={getEnvPagePageComponent(
          Scim,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            ),
            anyOf(
              EnvAppPermissions.ORG_SCIM_READ,
              EnvAppPermissions.ORG_SCIM_MANAGE
            )
          )
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.DIRECTORY_DETAILS)}
        component={getEnvPagePageComponent(
          Scim,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            ),
            anyOf(
              EnvAppPermissions.ORG_SCIM_READ,
              EnvAppPermissions.ORG_SCIM_MANAGE
            )
          )
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.MY_ACCOUNT)}
        component={getEnvPagePageComponent(
          MyProfile,
          LayoutTypes.TWO_COLUMN_WITH_NAV
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.MY_SECURITY)}
        component={getEnvPagePageComponent(
          Security,
          LayoutTypes.TWO_COLUMN_WITH_NAV
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.LIST_CONNECTIONS)}
        component={getEnvPagePageComponent(
          Sso,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            ),
            anyOf(
              EnvAppPermissions.ORG_SSO_READ,
              EnvAppPermissions.ORG_SSO_MANAGE
            )
          )
        )}
      />
      <Route
        path={getSlug.envAppPages(EnvAppPaths.CONNECTION_DETAILS)}
        component={getEnvPagePageComponent(
          Sso,
          LayoutTypes.TWO_COLUMN_WITH_NAV,
          allOf(
            anyOf(
              EnvAppPermissions.ORG_SETTINGS_READ,
              EnvAppPermissions.ORG_SETTINGS_MANAGE
            ),
            anyOf(
              EnvAppPermissions.ORG_SSO_READ,
              EnvAppPermissions.ORG_SSO_MANAGE
            )
          )
        )}
      />
    </Route>
  );
}
